/** Shallowly remove keys of an object whose values are undefined or empty array */
const shallowOmitEmpty = (obj) => Object.entries(obj).reduce((acc, [key, value]) => {
    if (!(value === undefined || (Array.isArray(value) && value.length === 0)))
        acc[key] = value;
    return acc;
}, {});
/**
 * This function return queryParams object without key having array value
 * @param queryParams Object containing query params
 */
const omitArrayValue = (queryParams) => {
    return Object.entries(queryParams).reduce((acc, [key, value]) => {
        return Array.isArray(value) ? acc : { ...acc, [key]: value };
    }, {});
};
/** We filter undefined values because URLSearchParams otherwise set keys but no value which is misinterpreted by the backend */
export const createQueryParams = (query) => {
    const queryParamsWithoutUndefinedValues = query ? shallowOmitEmpty(query) : {};
    const queryWithoutArray = omitArrayValue(queryParamsWithoutUndefinedValues);
    const hasKeys = Object.keys(queryParamsWithoutUndefinedValues).length !== 0;
    let queryParams = '';
    if (hasKeys) {
        // Initiate queryParamsString without array value
        const finalQueryParams = new URLSearchParams(queryWithoutArray);
        // Iterate over every queryParam and for each array value append array entry in finalQueryParams
        Object.entries(queryParamsWithoutUndefinedValues).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach((entry) => finalQueryParams.append(key, entry));
            }
        });
        // Do not miss the question mark before params
        queryParams = `?${finalQueryParams}`;
    }
    return queryParams;
};
export default createQueryParams;
